import { useContext, useEffect, useState, useCallback } from "react";

import ModalTemplate from "../../../common/ModalTemplate";
import { Context } from "../../Provider";
import { fetchSettings } from "../../service";
import DivSpinner from "../../../common/DivSpinner";
import { theme } from "../../../theme";
import CopyUrlBox from "./components/CopyUrlBox";
import WelcomeVideo from "./components/WelcomeVideo";
import WelcomeText from "./components/WelcomeText";
import QRDownload from "./components/QRDownload";
import HowWeWorkButton from "./components/HowWeWorkButton";
import FooterActions from "./components/FooterActions";

const Loading = () => (
    <div style={{ height: `${window.innerHeight - 387}px` }}>
        <DivSpinner />
    </div>
);

const Body = ({ details, setShowQr, showQr, handleCloseWelcomeModal }) => {
    const { settings } = details;

    return (
        <div className="card mt-4">
            <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <WelcomeVideo videoSrc={settings?.ftm_app_welcome_video} />
            </div>

            <div className="card-body">
                {!showQr ? (
                    <WelcomeText htmlContent={settings?.ftm_app_welcome_text} />
                ) : (
                    <QRDownload 
                        androidQr={settings?.ftm_android_app_qr}
                        iosQr={settings?.ftm_ios_app_qr}
                    />
                )}

                <HowWeWorkButton pdfUrl={settings?.ftm_app_welcome_pdf} />

                <CopyUrlBox 
                    url={window.location.href} 
                    name={<>Save Your Unique <br /> Registration Link</>} 
                />
            </div>

            <FooterActions 
                showQr={showQr} 
                setShowQr={setShowQr} 
                handleCloseWelcomeModal={handleCloseWelcomeModal}
                theme={theme}
            />
        </div>
    );
};

const Welcome = () => {
    const { state } = useContext(Context);
    const { ftm, step } = state;

    const [details, setDetails] = useState({ loading: true, settings: null });
    const [openWelcomeModal, setOpenWelcomeModal] = useState(false);
    const [showQr, setShowQr] = useState(false);

    const handleOpenWelcomeModal = useCallback(() => setOpenWelcomeModal(true), []);
    const handleCloseWelcomeModal = useCallback(() => setOpenWelcomeModal(false), []);

    const getSettings = useCallback(async () => {
        try {
            const response = await fetchSettings(ftm?.ftm_id);
            if (response?.status === "Success") {
                setDetails({ loading: false, settings: response.settings });
            } else {
                setDetails({ loading: false, settings: null });
            }
        } catch (error) {
            console.error("Error fetching settings:", error);
            setDetails({ loading: false, settings: null });
        }
    }, []);

    useEffect(() => {
        if (step?.stepId === 3) {
            handleOpenWelcomeModal();
            getSettings();
        }
    }, [step?.stepId, handleOpenWelcomeModal, getSettings]);

    return (
        <ModalTemplate
            show={openWelcomeModal}
            handleClose={handleCloseWelcomeModal}
            size="lg"
            centered
            title={null}
            body={details.loading ? <Loading /> : <Body details={details} setShowQr={setShowQr} showQr={showQr} handleCloseWelcomeModal={handleCloseWelcomeModal} />}
            footer={null}
            backdrop="static"
            keyboard={false}
            bodyBgColor="#F5F5F5"
        />
    );
};

export default Welcome;